import Vue from 'vue'
import VueRouter from 'vue-router'
import bus from 'bus'
import store from 'store'
import AnalyticsService from 'services/AnalyticsService'

import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
  routes,

  mode: 'history',

  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      if (to.path === from.path) {
        resolve()
        return
      }

      // Scroll the view to the saved position when returning to the list of activities
      if (to.name === 'dashboard.activities' && from.name === 'activity.overview') {
        bus.$once('dashboard.activitiesLoaded', () => resolve(savedPosition))
        return
      }

      // Scroll the view to the saved position when returning to the list of activities
      if (to.name === 'dashboard.calendar' && from.name === 'activity.overview') {
        bus.$once('dashboard.calendarLoaded', () => resolve(savedPosition))
        return
      }

      resolve({ x: 0, y: 0 })
    })
  }
})

// Datalayer reset
router.beforeEach((to, from, next) => {
  next()
  AnalyticsService.resetDatalayer()
})

// Most pages are async chunks, and a deploy replaces the chunk files. A tab
// opened before the deploy then cannot fetch the next page's chunk and the
// click does nothing, so load that page fresh instead. Not on the first
// navigation: that is the page load itself, and a reload would fail the same way.
let pendingPath = null

router.beforeEach((to, from, next) => {
  pendingPath = from.matched.length ? to.fullPath : null
  next()
})

router.onError((error) => {
  if (pendingPath && /Loading (CSS )?chunk .+ failed/i.test(error?.message || '')) {
    window.location.assign(pendingPath)
  }
})

// Back from the device service's hosted sign-in. Handled here rather than in a
// view because a rider returns to whichever screen sent them, and those do not
// share a path root: the planner is /app/plan, connections is
// /settings/connections. What actually connected is read from the server, never
// from this redirect; the marker then comes out of the URL so a refresh does
// not ask again.
router.afterEach((to) => {
  if (!to.query.stridee) return

  store.dispatch('planner/refreshStridee')
  const query = { ...to.query }
  delete query.stridee
  delete query.status
  router.replace({ path: to.path, query }).catch(() => {})
})

// Virtual pageview tracking
router.afterEach((to) => {
  // Send custom pageview event to Google tag manager
  setTimeout(() => {
    AnalyticsService.trackPageView(to.fullPath)
    AnalyticsService.ahoyTrackPageView(to.name)
  }, 600)
})

export default router
